export interface MarkType {
  value: number;
  label: string;
}

export interface IGlobalFilters {
  [key: string]: ColumnItem;
}

export enum FilterType {
  RANGE = 'range',
  VALUES = 'values',
  DYNAMIC = 'dynamic'
}

export enum DynamicFilterTypes {
  LAST_FULL = 'last_full',
  THIS = 'this'
}

export enum BaselineChoices {
  LAST_DATAPOINT = 'last_datapoint',
  TODAY = 'current_time'
}

type ColumnItemMap<T extends FilterType> = T extends FilterType.RANGE
  ? ColumnItemRange
  : T extends FilterType.DYNAMIC
  ? ColumnItemDynamicFilter
  : ColumnItemList;

export type ColumnItem = ColumnItemMap<FilterType>;
export enum isActiveFilter {
  TRUE = 'true',
  FALSE = 'false'
}

export interface ColumnItemRange {
  type: FilterType.RANGE;
  startValue: number;
  endValue: number;
  active: isActiveFilter;
}

export interface DateRange {
  start_date: string;
  end_date: string;
}

export interface ColumnItemDynamicFilter {
  filter: DynamicFilterTypes;
  number_of: number;
  group_choice: string;
  baseline: BaselineChoices;
  active: isActiveFilter;
}

export interface ColumnItemList {
  type: FilterType.VALUES;
  filterType: 'include' | 'exclude';
  values: string[];
  active: isActiveFilter;
}

export interface ColumnValues {
  values: number[] | string[];
  date_grouping: string;
  treat_as_type: 'DATE' | 'NUMBER' | 'TEXT' | 'DATETIME';
}
